import { render, staticRenderFns } from "./TestSelect.vue?vue&type=template&id=d3c19f16&"
import script from "./TestSelect.vue?vue&type=script&lang=js&"
export * from "./TestSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports